<template>
  <!-- MODAL EDIT -->
  <b-modal
    id="modalMDB"
    title="Main Distribution Board"
    size="xl"
    ok-only
  >
    <b-row>
      <b-col cols="12">
        <b-card>
          <!-- table -->
          <b-table
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(graph)="data">
              <b-link
                v-b-modal="'modalGraphMDB'"
                @click="$refs.childref.graphModalMDB(data.item.devid)"
              ><feather-icon
                class="text-primary"
                icon="TrendingUpIcon"
                size="20"
              />{{ data.value }}
              </b-link>
            </template>
            <template
              #cell(Trip)="data"
            >
              <b-badge
                v-if="data.item.ON >= 1"
                variant="success"
              >
                ON
              </b-badge>
              <b-badge
                v-if="data.item.Trip >= 1"
                variant="warning"
              >
                Trip
              </b-badge>
              <b-badge
                v-if="data.item.OFF >= 1"
                variant="danger"
              >
                OFF
              </b-badge>
            </template>
            <template #cell(connect)="data">
              <b-badge :variant="connect[1][data.value]">
                {{ connect[0][data.value] }}
              </b-badge>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <GraphMDB
      ref="childref"
      @fetch="getMDB()"
    />
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BCard, BTable, BBadge, BLink,
} from 'bootstrap-vue'
import GraphMDB from '@/views/StatisModal/Graph/GraphMDB.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BBadge,
    BLink,
    GraphMDB,
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'graph', label: 'Graph', class: 'text-center' },
        {
          key: 'devbuilding', label: 'Building', sortable: true, class: 'text-left',
        },
        {
          key: 'devid', label: 'ID', sortable: true, class: 'text-left',
        },
        {
          key: 'Trip', label: 'Status', sortable: true, class: 'text-center',
        },
        {
          key: 'lastupdate', label: 'LastUpdate', sortable: true, class: 'text-center',
        },
        {
          key: 'connect', label: 'Connected', sortable: true, class: 'text-center',
        },
      ],
      perPage: '',
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      connect: [{
        Offline: 'non-connect', Online: 'connect',
      },
      {
        Offline: 'light-danger', Online: 'light-success',
      }],
      status: [{
        Offline: 'non-connect', Online: 'connect',
      },
      {
        Offline: 'light-danger', Online: 'light-success',
      }],
    }
  },
  mounted() {
    this.getMDB()
  },
  methods: {
    getMDB() {
      axios
        .get('/get-tableMDB')
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.perPage = response.data.length
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
  },
}
</script>

<style>

</style>
